import { UserInterface } from "./interfaces/UserInterface";

export class User  {
    id?: number = undefined;
    password = undefined;
    language?: string = undefined;
    notificationSettings = {
        email: {
            meetings: false,
            comments: false,
            meetingsInvitationsDigest: false
        }
    };

    username?: string = undefined;

    constructor(data: UserInterface) {
        Object.assign(this, data);
    }
}